
@if( msgLastSave ) {

	<div
		style="font-size: small; color: darkgrey; text-align: center;"
	>
		{{msgLastSave}}
	</div>

}
